import styled from 'styled-components/macro';

export const Box = styled.div<any>`
  width: ${({ isLargeScreen }): string =>
    isLargeScreen ? '225px' : 'auto'}; // Width of ResourceItemCard
`;

export const Span = styled.span`
  font-size: 0.75em;
  font-weight: 700;
  letter-spacing: 1px;
  color: #bfc8d5;
`;
export const MoreResourcesWrapper = styled.div<any>`
  display: grid;
  justify-self: start;
  grid-template-columns: ${({ isLargeScreen }): string =>
    isLargeScreen ? '1fr 1fr 1fr' : '1fr'};
  gap: ${({ isLargeScreen }): string => (isLargeScreen ? '2em' : '0')};

  & > div:first-child {
    margin-bottom: ${({ isLargeScreen }): string =>
      isLargeScreen ? '0' : '.75em'};
  }
`;
export const ResourcesContainer = styled.div`
  text-decoration: none;
  display: flex;
  gap: 1.5em;
  flex-flow: row revert;
`;

export const LinkWrapper = styled.div`
  display: flex;
  flex-flow: column;
`;

export const Link = styled.a`
  text-decoration: none;
  font-weight: 700;
  color: ${({ theme }): string => theme.LightNightBlue};
  &:hover {
    color: ${({ theme }): string => theme.AccentGreen};
  }
`;
